import ActivityACHPage from "components/pages/ActivityACHPage";

export default function CaptureACHBatches(props) {
    return <ActivityACHPage/>;
}